export default __webpack_public_path__ + "static/media/6.66891f97.jpg";